import { isWithdrawnOrDuplicate } from './tshirtRosterEligibility';

/** Flyer roles that count as registered for this event (volunteer shift sign-up gate). */
export const REGISTERED_FLYER_TYPES = new Set(['freshling', 'mentor', 'volunteer']);

export function isRegisteredFlyerForVolunteerSignup(f) {
  if (!f || !REGISTERED_FLYER_TYPES.has(f.type)) return false;
  if (f.test || f.cancelled || isWithdrawnOrDuplicate(f)) return false;
  return true;
}

/** Stable key for email matching (Gmail ignores dots; googlemail.com ≡ gmail.com). */
export function volunteerEmailMatchKey(raw) {
  const e = (raw || '').toLowerCase().trim();
  if (!e.includes('@')) return null;
  const at = e.lastIndexOf('@');
  const local = e.slice(0, at).replace(/\./g, '');
  const domain = e.slice(at + 1);
  if (domain === 'gmail.com' || domain === 'googlemail.com') {
    return `g:${local}`;
  }
  return `e:${e}`;
}

/** Primary + linked-provider emails (Google/Apple etc. can differ from `user.email`). */
export function collectVolunteerGateEmailKeys(user) {
  const keys = new Set();
  const add = (addr) => {
    const k = volunteerEmailMatchKey(addr);
    if (k) keys.add(k);
  };
  if (user?.email) add(user.email);
  if (Array.isArray(user?.providerData)) {
    for (const p of user.providerData) {
      if (p?.email) add(p.email);
    }
  }
  return keys;
}

export function flyerEmailsMatchGateKeys(flyer, keys) {
  const k = volunteerEmailMatchKey(flyer?.email);
  return Boolean(k && keys.has(k));
}

/** `flyers.identityUid` is canonical once backfill completes; email is fallback during migration. */
export function flyerIdentityUidMatchesUser(flyer, user) {
  const fUid = (flyer?.identityUid || '').toString().trim();
  const uUid = (user?.uid || '').toString().trim();
  return Boolean(fUid && uUid && fUid === uUid);
}

/** Match precedence for migration: identityUid first, then email when flyer has no uid. */
export function volunteerGateFlyerMatchPath(flyer, user, emailKeys) {
  if (!isRegisteredFlyerForVolunteerSignup(flyer)) return 'none';
  if (flyerIdentityUidMatchesUser(flyer, user)) return 'identityUid';
  const noFlyerUid = !((flyer?.identityUid || '').toString().trim());
  if (noFlyerUid && flyerEmailsMatchGateKeys(flyer, emailKeys)) return 'email_fallback';
  return 'none';
}

